/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import AppContainer from "../../Components/Structure/AppContainer";
import ajaxBank from "../../util/remote/ajaxBank";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import DepositChargesPerVendor from "../../Components/Transactions/DepositChargesPerVendor";
import POSDepositChargesList from "../../Components/Transactions/POSDepositChargesList";

function DepositChargesPage() {
    const [loading5, setLoading5] = useState(false);
    const [loading6, setLoading6] = useState(false);
    const [vendorStartDate, setVendorStartDate] = useState("");
    const [vendorEndDate, setVendorEndDate] = useState("");
    const [vendorCharges, setVendorCharges] = useState(false);

    const [depositChargesTotal, setDepositChargesTotal] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);

    useEffect(() => {
  const fetchAll = async () => {
    setLoadingPage(true);
    await Promise.all([
      vendorStartDate || vendorEndDate ? searchTotalVendorCharges() : getTotalVendorCharges(),
      getDepositChargesTotal(),
    ]);
    setLoadingPage(false);
  };

  fetchAll();
}, []);

    const getTotalVendorCharges = async () => {
      setLoading5(true);
        const server_response = await ajaxBank.fetchTotalPOSDepositChargesForVendors();
        setLoading5(false);
        if (server_response.status === "OK") {
          setVendorCharges(server_response.details);
        } else {
          setVendorCharges("404");
        }
    };

    const searchTotalVendorCharges = async () => {
      setLoading6(true);
        const server_response = await ajaxBank.searchTotalPOSDepositChargesForVendors(vendorStartDate, vendorEndDate);
        setLoading6(false);
        if (server_response.status === "OK") {
          setVendorCharges(server_response.details);
        } else {
          setVendorCharges("404");
        }
    };

    const getDepositChargesTotal = async () => {
      const server_response = await ajaxBank.fetchTotalPOSDepositCharges();
      if (server_response.status === "OK") {
        setDepositChargesTotal(server_response.details);
      } else {
        setDepositChargesTotal("404");
      }
    };

    const setVendorCharge = (e) => {
      e.preventDefault();
      setVendorStartDate("");
      setVendorEndDate("");
      getTotalVendorCharges();
      
    };

  return (
    <AppContainer title="POS Deposit Charges">
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
                          // Full page skeleton loader
                          <div style={{ padding: 40 }}>
                            <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                            <Skeleton height={200} style={{ marginBottom: 20 }} />
                            <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
                          </div>
                        ) : (
      <div className="row">
        <div className="col-lg-4">
          <div className="row">
            <DepositChargesPerVendor depositCharges={vendorCharges} loading={loading5} loading2={loading6}
            startDate={vendorStartDate} setStartDate={setVendorStartDate} endDate={vendorEndDate} setEndDate={setVendorEndDate} searchDepositCharges={searchTotalVendorCharges}
            resetSearch={setVendorCharge}/>
          </div> 
        </div>
        
        <div className="col-lg-8">
          <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            UGX. {depositChargesTotal? depositChargesTotal.total_c:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> POS Deposit Charges</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <POSDepositChargesList/>
            

          </div>
        </div>

        
      </div>)}
    </AppContainer>
  );
}

export default DepositChargesPage;
